import { Link } from "@tanstack/react-router";
import { AuthShell } from "../../components/auth/AuthShell";

/**
 * AUTH-04 — AMCaaS (B2C) **provider** login: https://amcaas.app/login/provider.
 *
 * Second provider door, on the B2C host. Providers are a single entity shared
 * across both apps (TOP-06) and land in the same host-agnostic console no matter
 * which door they used (AUTH-10). Here they also see their B2C subscribers as
 * self-registered clients in that same console (COS-07). App-branded only (WL-03).
 */
export function AmcaasProviderLoginPage(): JSX.Element {
  return (
    <AuthShell
      appName="AMCaaS"
      appTagline="Application Maintenance Contracts as a Service"
      logoSrc="/logos/amcaas-login-banner.png"
      logoSrc2x="/logos/amcaas-login-banner@2x.png"
      accent="#a855f7"
      panelClassName="bg-gradient-to-br from-zinc-950 via-zinc-900 to-fuchsia-950"
      audienceLabel="Provider sign-in"
      headline="Turn every warranty into revenue. Stop chasing renewals. Start owning them."
      blurb="From catalogue to renewal, run your entire AMC business in one place — reach new consumers through the marketplace without losing control of your direct relationships.
Discover and subscribe to AMC plans in minutes, track every asset you own, and never miss a renewal again — all from one place."
      quote={{
        text: "Listing on the marketplace brought us subscribers we would never have reached.",
        author: "Sofia Marin, COO, BrightStack",
      }}
      footer={
        <p>
          Looking for the marketplace?{" "}
          <Link
            to="/login/platform"
            className="font-medium text-foreground hover:underline"
          >
            Platform sign-in
          </Link>
        </p>
      }
    />
  );
}
